// extracted by mini-css-extract-plugin
module.exports = {"embed":"EmbedBlock_embed__jNNYk","inner":"EmbedBlock_inner__ZwCQf","content":"EmbedBlock_content__YUva_"};